export const FACTION_INFO: Record<string, { name: string; color: string; description: string; icon: string }> = {
  navy: {
    name: 'The Navy',
    color: '#3498db',
    description: 'The military arm of The Regime. Values order, justice, and the rule of law.',
    icon: '/assets/factions/navy.png',
  },
  pirate: {
    name: 'Pirate Lords',
    color: '#e74c3c',
    description: 'A loose alliance of three pirate factions: Crimson Corsairs (wealth), Stormbreaker Syndicate (freedom), and Obsidian Reavers (conquest).',
    icon: '/assets/factions/corsairs.png',
  },
  corsairs: {
    name: 'Crimson Corsairs',
    color: '#dc143c',
    description: 'Mercenary pragmatists seeking wealth and power. The largest pirate fleet, searching for pre-Riftfall artifacts.',
    icon: '/assets/factions/corsairs.png',
  },
  stormbreaker: {
    name: 'Stormbreaker Syndicate',
    color: '#1e3a8a',
    description: 'Idealists who believe the Riftfall was intentional. They liberate enslaved sailors and recruit Wildcards.',
    icon: '/assets/factions/stormbreaker.png',
  },
  reavers: {
    name: 'Obsidian Reavers',
    color: '#1f2937',
    description: 'Conquerors led by Warlord Kaine, searching for the legendary Void Anchor. Values strength and dominance.',
    icon: '/assets/factions/reavers.png',
  },
  merchant: {
    name: 'Merchant Guild',
    color: '#f39c12',
    description: 'The economic backbone of the seas. Values profit, trade, and stability.',
    icon: '/assets/factions/merchants.png',
  },
  smuggler: {
    name: 'Smugglers Network',
    color: '#8e44ad',
    description: 'An underground network dealing in contraband. Values secrecy, cunning, and profit.',
    icon: '/assets/factions/smugglers.png',
  },
};

export const getFactionIcon = (factionId: string | null | undefined): string => {
  if (!factionId) return '';
  return FACTION_INFO[factionId]?.icon || '';
};

export const getFactionColor = (factionId: string | null | undefined): string => {
  if (!factionId) return '#8b949e';
  return FACTION_INFO[factionId]?.color || '#8b949e';
};

export const getFactionName = (factionId: string | null | undefined): string => {
  if (!factionId) return 'Unknown';
  return FACTION_INFO[factionId]?.name || 'Unknown';
};
